import { Injectable } from '@angular/core';
import { TreeviewItem } from 'ngx-treeview1';
import { Observable } from 'rxjs';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AccountingService {

  constructor(public globalHelper: GlobalHelper, private httpclient: HttpClient) { }
  
  GetAllAccount(): Observable<any> {
    // var param = 'objModel' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Acc/GetAllAccount' , { headers: reqHeader });
  }
  ImportAccount(): Observable<any> {
    
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/ImportAccount?', { headers: reqHeader });
 }
  SaveAccount(objAccount): Observable<any> {
     var param = 'objAccount=' + objAccount;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'Acc/SaveAccount?'+encodeURI(param), { headers: reqHeader });
  }
  DeleteAccount(objAccount): Observable<any> {
    var param = 'objAccount=' + objAccount;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/DeleteAccount?'+encodeURI(param), { headers: reqHeader });
 }
 UpdateGroupAccount(objAccount): Observable<any> {
    var param = 'objAccount=' + objAccount;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/UpdateGroupAccount?'+encodeURI(param), { headers: reqHeader });
 }
 //--Start Bank Payment--//
 SaveVoucherPayment(objPayment,objList): Observable<any> {
  var param = 'objPayment=' + objPayment+"&objList="+objList;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/SaveVoucherPayment?'+encodeURI(param), { headers: reqHeader });
}
GetVoucherPayment(DebitAccID): Observable<any> {
  var param = 'DebitAccID=' + DebitAccID;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetVoucherPayment?'+encodeURI(param), { headers: reqHeader });
}
GetVoucherPaymentDetails(TransID): Observable<any> {
var param = 'TransID=' + TransID;
var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
 'Acc/GetVoucherPaymentDetails?'+encodeURI(param), { headers: reqHeader });
}
    //--Start Bank Payment--//
    SaveBankPayment(objPayment,objList): Observable<any> {
        var param = 'objPayment=' + objPayment+"&objList="+objList;
       var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
         'Acc/SaveBankPayment?'+encodeURI(param), { headers: reqHeader });
     }
     GetBankPayment(DebitAccID): Observable<any> {
        var param = 'DebitAccID=' + DebitAccID;
       var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
         'Acc/GetBankPayment?'+encodeURI(param), { headers: reqHeader });
     }
     GetBankPaymentVoucherDetails(TransID): Observable<any> {
      var param = 'TransID=' + TransID;
     var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
       'Acc/GetBankPaymentVoucherDetails?'+encodeURI(param), { headers: reqHeader });
   }

  //--Start Bank Receipt--//
  SaveVoucherReceipt(objPayment): Observable<any> {
    var param = 'objPayment=' + objPayment;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/SaveVoucherReceipt?'+encodeURI(param), { headers: reqHeader });
 }
 GetVoucherReceipt(CreditAccID): Observable<any> {
    var param = 'CreditAccID=' + CreditAccID;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/GetVoucherReceipt?'+encodeURI(param), { headers: reqHeader });
 }
 GetVoucherReceiptDetails(TransID): Observable<any> {
  var param = 'TransID=' + TransID;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetVoucherReceiptDetails?'+encodeURI(param), { headers: reqHeader });
}




     //--Start Bank Receipt--//
     SaveBankReceipt(objPayment): Observable<any> {
      var param = 'objPayment=' + objPayment;
     var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
       'Acc/SaveBankReceipt?'+encodeURI(param), { headers: reqHeader });
   }
   GetBankReceipt(CreditAccID): Observable<any> {
      var param = 'CreditAccID=' + CreditAccID;
     var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
       'Acc/GetBankReceipt?'+encodeURI(param), { headers: reqHeader });
   }
   GetBankReceiptVoucherDetails(TransID): Observable<any> {
    var param = 'TransID=' + TransID;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/GetBankReceiptVoucherDetails?'+encodeURI(param), { headers: reqHeader });
 }
    //--Start Bank Payment--//
    SaveCashPayment(objPayment,objList): Observable<any> {
      var param = 'objPayment=' + objPayment+"&objList="+objList;
     var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
       'Acc/SaveCashPayment?'+encodeURI(param), { headers: reqHeader });
   }
   GetCashPayment(CreditAccID): Observable<any> {
      var param = 'strCashVoucher=' + CreditAccID;
     var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
       'Acc/GetCashPayment?'+encodeURI(param), { headers: reqHeader });
   }
   GetCashPaymentVoucherDetails(TransID): Observable<any> {
    var param = 'TransID=' + TransID;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/GetCashPaymentVoucherDetails?'+encodeURI(param), { headers: reqHeader });
 }
  //--Start Cash Receipt--//
  SaveCashReceipt(objPayment): Observable<any> {
    var param = 'objPayment=' + objPayment;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/SaveCashReceipt?'+encodeURI(param), { headers: reqHeader });
 }
 GetCashReceipt(CreditAccID): Observable<any> {
    var param = 'CreditAccID=' + CreditAccID;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/GetCashReceipt?'+encodeURI(param), { headers: reqHeader });
 }
 GetCashReceiptVoucherDetails(TransID): Observable<any> {
  var param = 'TransID=' + TransID;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetCashReceiptVoucherDetails?'+encodeURI(param), { headers: reqHeader });
}
  //--Start Cash Journal--//
  SaveJournal(objPayment,details): Observable<any> {
    var param = 'objPayment=' + objPayment+ "&details="+details;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/SaveJournal?'+encodeURI(param), { headers: reqHeader });
 }
 GetJournal(strBank): Observable<any> {
    var param = 'strBank=' + strBank;
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
     'Acc/GetJournal?'+encodeURI(param), { headers: reqHeader });
 }
 GetJournalVoucherDetails(TransID): Observable<any> {
  var param = 'TransID=' + TransID;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetJournalVoucherDetails?'+encodeURI(param), { headers: reqHeader });
}
GetJournalReport(strBank): Observable<any> {
  var param = 'strBank=' + strBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetJournalReport?'+encodeURI(param), { headers: reqHeader });
}
GetTrialbalanceReport(strBank): Observable<any> {
  var param = 'strBank=' + strBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetTrialbalanceReport?'+encodeURI(param), { headers: reqHeader });
}
GetOpeningBalancePost(strBank): Observable<any> {
  var param = 'strBank=' + strBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetOpeningBalancePost?'+encodeURI(param), { headers: reqHeader });
}
SaveOpeningBalancePost(List, data,):Observable<any>{  
  
  let formData = new FormData();
  formData.append("strPayment", data);
  formData.append("objPayment", List);
 
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Acc/SaveOpeningBalancePost', formData);
 
}
GetLedger(strdata): Observable<any> {
  var param = 'strdata=' + strdata;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetLedger?'+encodeURI(param), { headers: reqHeader });
}
GetProfitLossReport(strBank): Observable<any> {
  var param = 'strBank=' + strBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetProfitLossReport?'+encodeURI(param), { headers: reqHeader });
}
GetBalancesheetReport(strBank): Observable<any> {
  var param = 'strBank=' + strBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetBalancesheetReport?'+encodeURI(param), { headers: reqHeader });
}
GetVoucherReport(strdata): Observable<any> {
  var param = 'strdata=' + strdata;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetVoucherReport?'+encodeURI(param), { headers: reqHeader });
}

SaveBank(objBank): Observable<any> {
  var param = 'objBank=' + objBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/SaveBank?'+encodeURI(param), { headers: reqHeader });
}
GetAllBank(): Observable<any> {
  
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetAllBank', { headers: reqHeader });
}
MarkBankActive(objBank): Observable<any> {
  var param = 'objBank=' + objBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/MarkBankActive?'+encodeURI(param), { headers: reqHeader });
}
UpdateBankAccount(BankAccountID,IsActive): Observable<any> {
  var param = 'BankAccountID=' + BankAccountID+'&IsActive='+IsActive;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/UpdateBankAccount?'+encodeURI(param), { headers: reqHeader });
}
SaveBankDetails(objBank): Observable<any> {
  var param = 'objBank=' + objBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/SaveBankDetails?'+encodeURI(param), { headers: reqHeader });
}
SearchBankDetails(objBank): Observable<any> {
  var param = 'objBank=' + objBank;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/SearchBankDetails?'+encodeURI(param), { headers: reqHeader });
}
SaveVendor(objVendor): Observable<any> {
  var param = 'objVendor=' + objVendor;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/SaveVendor?'+encodeURI(param), { headers: reqHeader });
}
GetAllVendor(strFilter): Observable<any> {
  var param = 'strFilter=' + strFilter;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/GetAllVendor?'+encodeURI(param), { headers: reqHeader });
}
SaveFeeDailyClosing(objPayment,PaymentList,PaymentModeAmountList):Observable<any>{  
;
    let formData = new FormData();
    formData.append("objPayment", objPayment);
    formData.append("PaymentList", PaymentList);
    formData.append("PaymentModeAmountList", PaymentModeAmountList);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Finance/SaveFeeDailyClosing', formData);
    
}
GetFeeDailyClosing(strdata):Observable<any>{  
  let param='strStudent=' +strdata;  
  var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl
    +'Finance/GetFeeDailyClosing?'
    +encodeURI(param),{headers:reqHeader});
}
GetPostFeeDaily(objReceipt):Observable<any>{  
  let param='objReceipt=' +objReceipt;  
  var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl
    +'Acc/GetPostFeeDaily?'
    +encodeURI(param),{headers:reqHeader});
}
SavePostFeeDaily(data, List, UserList, PaymentModeAmountList):Observable<any>{  
  
  let formData = new FormData();
  formData.append("objPayment", data);
  formData.append("PaymentList", List);
  formData.append("UserList", UserList);
  formData.append("PaymentModeAmountList", PaymentModeAmountList); 
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Acc/SavePostFeeDaily', formData);
 
}
SavePostModernExchangeFeeDaily(data, List, UserList):Observable<any>{  
  
  let formData = new FormData();
  formData.append("objPayment", data);
  formData.append("PaymentList", List);
  formData.append("UserList", UserList); 
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Acc/SavePostModernExchangeFeeDaily', formData);
 
}
GetPostModernExchangeFeeDaily(objReceipt):Observable<any>{  
  let param='objReceipt=' +objReceipt;  
  var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl
    +'Acc/GetPostModernExchangeFeeDaily?'
    +encodeURI(param),{headers:reqHeader});
}
CancelVoucher(objPayment): Observable<any> {
  var param = 'objPayment=' + objPayment;
 var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
   'Acc/CancelVoucher?'+encodeURI(param), { headers: reqHeader });
}
}
